export default function getTextInitials(text) {
  if (text) {
    const firstTwoWords = text.split(" ").slice(0, 2);
    return firstTwoWords.map((part) => part.charAt(0)).join("");
  }
  return "";
}
